<template>
  <div class="banner">
    <p class="text-center">
      <img :src="logo()" />
    </p>
    <h2 class="text-center title">{{ title | capitalize }}</h2>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    title: {
      type: String,
      default: () => ""
    }
  },
  data: () => ({}),
  methods: {
    logo() {
      return process.env.VUE_APP_IMAGES + "logo.png";
    }
  },
  filters: {
    capitalize(value) {
      return value[0].toUpperCase() + value.substring(1);
    }
  }
};
</script>

<style lang="scss">
.banner {
  height: 350px;
  background: url("../assets/images/grain_elevator.jpg");
  background-size: cover;
  background-position: 50%;
  img {
    max-width: 250px;
  }

  .title {
    color: white;
    text-shadow: 0 0 3px #000;
  }
}
</style>
